import { Injectable } from "@angular/core";
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserServiceConfig {
  private isConfigLoaded = false;

  constructor() {}

  async loadSensitiveConfig(): Promise<void> {
    if (this.isConfigLoaded) {
      return;
    }

    try {
      // Determine config file path
      const configFile = "/assets/config/environment.json"
      
      // Use fetch to load JSON
      const response = await fetch(configFile);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const sensitiveConfig = await response.json();
      
      // Merge sensitive data into the environment object
      Object.assign(environment, sensitiveConfig);
      
      this.isConfigLoaded = true;
      console.log(`Configuration loaded successfully`);
    } catch (error) {
      console.error('Failed to load configuration:', error);
      throw error;
    }
  }

  isLoaded(): boolean {
    return this.isConfigLoaded;
  }
}
